<template>
  <v-btn
    v-if="isBtnVisible"
    depressed
    color="primary"
    class="button-base"
    @click="btnClickHandler"
    :loading="loading"
  >
    Повторно отправить ИН в ФССП
  </v-btn>
</template>

<script>
import { RouteName } from '@/router';
import { deleteResendToFsspAddStmnt } from '@/api/editedStatement';
import { statusInfoService } from '@/services';
import { AdditionalStatementType } from '@/constants';

export default {
  name: 'ResendToFsspBtn',
  props: {
    statusInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    isBtnVisible() {
      return statusInfoService.canResendToFssp(this.statusInfo);
    },

    resendToFsspAddStmts() {
      return this.statusInfo.additionalStatements.filter(
        (addStatement) =>
          addStatement.type === AdditionalStatementType.RESEND_TO_FSSP
      );
    },

    resendToFsspDraft() {
      return statusInfoService.getResendToFsspDraft(
        this.statusInfo.additionalStatements
      );
    },
  },
  methods: {
    goToResendPage() {
      this.$router.push({
        name: RouteName.RESEND_TO_FSSP_APPLICANT,
        params: { altStatementId: this.resendToFsspDraft.id },
      });
    },

    async deleteExtraResendToFsspAddStmnts() {
      this.loading = true;
      await deleteResendToFsspAddStmnt(this.statusInfo.statementId);
      this.loading = false;
    },

    async btnClickHandler() {
      if (this.resendToFsspAddStmts.length > 1) {
        await this.deleteExtraResendToFsspAddStmnts();
      }

      this.goToResendPage();
    },
  },
};
</script>
